/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlayListDto } from '../../models/play-list-dto';

export interface PlaylistControllerFindById$Params {
  id: string;
}

export function playlistControllerFindById(http: HttpClient, rootUrl: string, params: PlaylistControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayListDto>> {
  const rb = new RequestBuilder(rootUrl, playlistControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlayListDto>;
    })
  );
}

playlistControllerFindById.PATH = '/api/playlist/{id}';
